<template>
  <div>
    <header class="flex gap-x-1 items-center justify-between p-2 mb-2">
      <wui-btn
        data-test="back-to-custom-reactions-list-btn"
        icon
        prepend-icon="expandMoreBig"
        class="rotate-90"
        :size="32"
        variant="neut"
        state="alpha"
        :title="$t('common.back')"
        @click="$emit('editModeOff')"
      />
      <p class="text-1316 text-fg-base-fg3">
        {{ $t('chat.createReaction') }}
      </p>
      <wui-btn
        data-test="close-reactions-menu-btn"
        icon
        :size="32"
        variant="neut"
        state="alpha"
        :title="$t('common.closeWindow')"
        prepend-icon="closeRegularMdM"
        @click="$emit('closeReactionMenu')"
      />
    </header>
    <div
      class="mx-2 flex flex-col items-center justify-center"
    >
      <div
        v-if="!customTextReactions.length"
        class="flex h-[102px] flex-col items-center justify-center text-center font-light text-1316 text-fg-base-fg22"
      >
        <p class="mb-2 max-w-[150px]">
          {{ $t('chat.twentyCustomReactionsOnly') }}
        </p>
        <p class="max-w-[170px]">
          {{ $t('chat.noMoreThanTenSymbols') }}
        </p>
      </div>

      <div
        v-else
        class="flex flex-wrap content-start justify-center gap-2 p-1 overflow-y-auto h-[96px] max-h-[96px] max-w-[220px] mb-2"
      >
        <div
          v-for="(customTextReaction, index) in customTextReactions"
          :key="`reaction-${index}-${customTextReaction}`"
          data-test="custom-reaction-in-edit-mode"
          class="chips-shadow flex h-6 items-center justify-start text-1316 gap-x-1 rounded-6 bg-bg-base-bg3 text-fg-base-fg3 border border-bor-nav"
        >
          <p class="py-1 pl-2">
            {{ customTextReaction }}
          </p>
          <div
            data-test="delete-custom-reaction-btn"
            class="hover:bg-surf-neut-soft-hov flex items-center justify-center rounded-6 w-6 h-6 cursor-pointer"
            @click.stop="deleteCustomReaction(index)"
          >
            <wui-icon
              name="clear"
              small
              class="text-fg-base-fg3"
            />
          </div>
        </div>
      </div>
      <div
        class="flex items-center gap-x-1"
      >
        <wui-input
          v-model="customTextReactionToAdd"
          :placeholder="customTextReactions.length > 19 ? $t('chat.limitHasBeenReached') : $t('chat.reactionText')"
          :disabled="customTextReactions.length > 19"
          :danger="customTextReactionToAdd.length > 10 || customTextReactions.includes(customTextReactionToAdd)"
          @keydown.enter.stop="addCustomTextReactionCall"
        />
        <wui-btn
          icon
          :size="32"
          prepend-icon="plusAddM"
          auto-loading
          :disabled="customTextReactionToAdd.length > 10 || !customTextReactionToAdd.length"
          @click="addCustomTextReactionCall"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiBtn, WuiInput, WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

import { useReactionsStore } from '@/entities/reaction'

defineEmits<{
  (event: 'closeReactionMenu'): void
  (event: 'editModeOff'): void
}>()

const { addCustomTextReaction, deleteCustomTextReaction } = useReactionsStore()
const { customTextReactions } = storeToRefs(useReactionsStore())
const customTextReactionToAdd = ref('')

const addCustomTextReactionCall = async () => {
  if (customTextReactionToAdd.value.trim()
        && !customTextReactions.value.includes(customTextReactionToAdd.value)
        && customTextReactionToAdd.value.length <= 10
      && customTextReactions.value.length < 20) {
    await addCustomTextReaction(customTextReactionToAdd.value)
    customTextReactionToAdd.value = ''
  }
}

const deleteCustomReaction = async (index: number) => {
  await deleteCustomTextReaction(index)
}
</script>

<style scoped>
.chips-shadow {
  box-shadow: none;
}
</style>

